import React, { memo, useMemo } from "react";
import "./TimeRenderListView.scss";

interface TimeRenderListViewProps {
    timeDiffStatus: string;
    time: string;
    diffInDays?: number;
}

const RedIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
      <path
        fillRule="evenodd" clipRule="evenodd" d="M10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 13.7279 13.7279 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25ZM10 4.2625C6.83127 4.2625 4.2625 6.83127 4.2625 10C4.2625 13.1687 6.83127 15.7375 10 15.7375C13.1687 15.7375 15.7375 13.1687 15.7375 10C15.7375 6.83127 13.1687 4.2625 10 4.2625ZM10 12.3625C10.2796 12.3625 10.5062 12.5892 10.5062 12.8688C10.5062 13.1483 10.2796 13.375 10 13.375C9.72041 13.375 9.49375 13.1483 9.49375 12.8688C9.49375 12.5892 9.72041 12.3625 10 12.3625ZM10 6.625C10.2563 6.625 10.4681 6.81545 10.5016 7.06256L10.5062 7.13125V11.35C10.5062 11.6296 10.2796 11.8562 10 11.8562C9.74371 11.8562 9.53189 11.6658 9.49837 11.4187L9.49375 11.35V7.13125C9.49375 6.85166 9.72041 6.625 10 6.625Z" fill="#DB0B00"/>
    </svg>
  );

const YellowIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
        <path fillRule="evenodd" clipRule="evenodd" d="M10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 13.7279 13.7279 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25ZM10 4.2625C6.83127 4.2625 4.2625 6.83127 4.2625 10C4.2625 13.1687 6.83127 15.7375 10 15.7375C13.1687 15.7375 15.7375 13.1687 15.7375 10C15.7375 6.83127 13.1687 4.2625 10 4.2625ZM10 12.3625C10.2796 12.3625 10.5062 12.5892 10.5062 12.8688C10.5062 13.1483 10.2796 13.375 10 13.375C9.72041 13.375 9.49375 13.1483 9.49375 12.8688C9.49375 12.5892 9.72041 12.3625 10 12.3625ZM10 6.625C10.2563 6.625 10.4681 6.81545 10.5016 7.06256L10.5062 7.13125V11.35C10.5062 11.6296 10.2796 11.8562 10 11.8562C9.74371 11.8562 9.53189 11.6658 9.49837 11.4187L9.49375 11.35V7.13125C9.49375 6.85166 9.72041 6.625 10 6.625Z" fill="#DE750C"/>
    </svg>
);

const renderIcon = (timeDiffStatus: string) => {
    return (
        <span className="time-render-list-view-icon">
            {timeDiffStatus === "overdue" ? <RedIcon/> : null}
            {timeDiffStatus === "within-5-mins" ? <YellowIcon/> : null}
        </span>
    );
};

const TimeRenderListView: React.FC<TimeRenderListViewProps> = memo(({ timeDiffStatus, time, diffInDays }) => {
    const icon = useMemo(() => renderIcon(timeDiffStatus), [timeDiffStatus]);
    
    return (
        <span className={`time-render-list-view time-render-list-view-${timeDiffStatus}`}>
            {icon}
            <span className="time-render-list-view-time">
                {time}
            </span>
            <span className="time-render-list-view-days">
                {diffInDays && diffInDays > 0 &&
                    `+${diffInDays}`}
            </span>
        </span>
    );
});


export default TimeRenderListView;